<div class="grid grid-cols-2">
    <div class="flex items-end">
        <p>{{ endCode || 'E300627' }} D240725 V2 AR</p>
    </div>

    <div id="sign" class="flex flex-col items-end">
        <div class="signature-container border-b border-solid p-2">
            @if (signature) {
                <img [src]="signature" alt="Signature" class="signature-image" />
            }
        </div>
        <p class="text-center">Contractor’s Acknowledgement</p>
    </div>
</div>
